import { useEffect } from "react";

export function usePageMeta(title: string, description?: string, keywords?: string) {
  useEffect(() => {
    document.title = title;
    if (description) {
      const el = document.querySelector('meta[name="description"]');
      if (el) el.setAttribute("content", description);
    }
    if (keywords) {
      const el = document.querySelector('meta[name="keywords"]');
      if (el) el.setAttribute("content", keywords);
    }
  }, [title, description, keywords]);
}